export enum CommunicationUserType {
  USERS = 'users',
  DRIVERS = 'drivers'
}